import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
function useLinkSupport() {
  const history = useHistory();
  const absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
  const origin = () => {
    if (window.location.origin) {
      return `${window.location.origin}`;
    }

    // IE, of course
    return `${window.location.protocol}//${window.location.host}`;
  };
  const onInternalClick = (event, anchorElement) => {
    if (!anchorElement) {
      return false;
    }
    const href = anchorElement.href.replace(`${origin()}/`, '');

    // intercept and do nothing if href is undefined or `#`
    if (!href || href === '#') {
      event.preventDefault();
      return false;
    }

    // handle CTRL while clicking the link
    const isAbsolute = absoluteUrlRegex.test(href);
    if (isAbsolute || event.metaKey || event.ctrlKey) {
      window.open(isAbsolute ? href : `${origin()}/${href}`);
      event.preventDefault();
      return true;
    }

    // do not intercept mailto:, and anchor URLs
    if (href.indexOf('mailto:') === 0 || href.indexOf('#') === 0) {
      return false;
    }

    // intercept and navigate router
    event.preventDefault();
    history.push(`/${href}`);
    return true;
  };
  const onExternalClick = (event, anchorElement) => {
    if (!anchorElement) {
      return false;
    }
    window.open(anchorElement.href);
    event.preventDefault();
    return true;
  };
  const findAnchorElement = target => {
    let currentTarget = target;
    while (currentTarget !== null && currentTarget.nodeName !== 'A') {
      if (currentTarget) {
        currentTarget = currentTarget.parentNode;
      }
    }
    if (currentTarget instanceof HTMLAnchorElement) {
      return currentTarget;
    }
    return null;
  };
  const onDocumentClick = event => {
    const {
      target
    } = event;
    const anchorElement = target instanceof Node ? findAnchorElement(target) : null;
    if (anchorElement && anchorElement.rel === 'ignore') {
      return false;
    }
    if (anchorElement && anchorElement.rel === 'external') {
      return onExternalClick(event, anchorElement);
    }
    return onInternalClick(event, anchorElement);
  };
  useEffect(() => {
    document.addEventListener('click', onDocumentClick);
    return () => document.removeEventListener('click', onDocumentClick);
  });
}
export default useLinkSupport;